export const HouseInsuranceRulesFiles: React.FC = () => {
  return (
    <div className="gap-6">
      <ul className="my-4">
        <li>
          <a
            href="https://assets.vienasaskaita.lt/files/plans/B%C5%ABsto%20valdytojo%20CA%20draudimo%20sertifikato%20pavyzdys.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Būsto valdytojo CA draudimo sertifikato pavyzdys ir sąlygos
          </a>
        </li>
        <li>
          <a
            href="https://assets.vienasaskaita.lt/files/plans/B%C5%ABsto%20valdytojo%20CA%20draudimo%20produkto%20informacijos%20dokumentas.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Būsto valdytojo CA draudimo produkto informacijos dokumentas
          </a>
        </li>
        <li>
          <a
            href="https://cms.vienasaskaita.lt/uploads/Busto_valdytojo_CA_ir_asmens_CA_draudimu_paslaugos_teikimo_salygos_628040737e.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Būsto valdytojo CA ir asmens CA draudimų teikimo sąlygos
          </a>
        </li>
        <li>
          <a
            href="https://cms.vienasaskaita.lt/uploads/COMPENSA_asmens_CA_draudimo_taisykles_nuo_2020_07_01_8022_b55beebc10.pdf"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Draudiko COMPENSA draudimo taisyklės
          </a>
        </li>
        <li>
          Informacija apie{" "}
          <a
            href="https://assets.vienasaskaita.lt/files/plans/Informacija%20apie%20draudimo%20broker%C4%AF%20EDRAUDA.pdf"
            className="text-blue-dark hover:underline"
          >
            draudimo brokerį EDRAUDA
          </a>
        </li>
        <li>
          <a
            href="https://www.edrauda.lt/draudimas/privatumo-politika/"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            Draudimo brokerio EDRAUDA
          </a>{" "}
          ir{" "}
          <a
            href="https://www.compensa.lt/privatumo-politika/"
            target="_blank"
            className="text-blue-dark hover:underline"
          >
            draudiko privatumo politika
          </a>
        </li>
      </ul>
    </div>
  );
};
